import {
    CLIENTE_AREA_MODO_TELA,
    CLIENTE_AREA_SET_AGUARDANDO,
    CLIENTE_AREA_LISTADO
} from './clienteAreaActions';

const INITIAL_STATE = {
    registro: {},
    modoTela: 'lista',
    aguardando: false,
    lista: [],
    listaSelect: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CLIENTE_AREA_MODO_TELA:
            return {
                ...state,
                modoTela: action.payload.modo,
                registro: action.payload.registro || {}
            };

        case CLIENTE_AREA_SET_AGUARDANDO:
            return {
                ...state,
                aguardando: action.payload
            };

        case CLIENTE_AREA_LISTADO: {
            const lista = action.payload.data || [];

            return {
                ...state,
                lista,
                listaSelect: lista.map(item => ({
                    id: item.id,
                    valor: item.nome
                }))
            };
        }

        default:
            return state;
    }
};